import { ComponentPropsWithoutRef, PropsWithChildren } from 'react'
import { cn } from '~shared/utils/cn'

export interface SuccessViewProps extends ComponentPropsWithoutRef<'div'> {}

export const SuccessView = (props: SuccessViewProps) => {
  const { className, ...rest } = props

  return (
    <div
      className={cn(
        'w-[355px] md:w-[614px] lg:w-[704px] p-[28px] md:p-[40px] flex flex-col items-center justify-center text-center',
        className
      )}
      {...rest}>
      <h2 className='text-[30px] md:text-[50px] leading-[0.9] tracking-[-0.04em] font-medium'>
        Ваши данные успешно отправлены
      </h2>
      <p className='mt-[24px] text-[16px] leading-[1.1]'>
        Наш менеджер свяжется с&nbsp;вами в&nbsp;ближайшее время
      </p>
    </div>
  )
}

export interface SuccessViewBoundaryProps
  extends SuccessViewProps,
    PropsWithChildren {
  isSuccess: boolean
}

export const SuccessViewBoundary = ({
  isSuccess,
  children,
  ...rest
}: SuccessViewBoundaryProps) => {
  if (isSuccess) return <SuccessView {...rest} />

  return <>{children}</>
}
